<div class="-m-6 flex max-h-screen max-w-240 flex-col md:min-w-160">
    <!-- Header -->
    <div class="flex h-16 flex-0 items-center justify-between bg-primary pl-6 pr-3 text-on-primary sm:pl-8 sm:pr-5">
        <div class="text-lg font-medium">Informazioni sul pagamento</div>

        <button mat-icon-button (click)="saveAndClose()" [tabIndex]="-1">
            <mat-icon
                class="text-current"
                [svgIcon]="'heroicons_outline:x-mark'"
            ></mat-icon>
        </button>


    </div>



    <div *ngIf="pagamento.stato=='INSERITO'">

        IN ATTESA DI RICEVUTA DI PAGAMENTOxxxxxxxxxxx


    </div>


    <p>{{pagamento.stato}}</p>



    <p>IN ATTESA DI RICEVUTA DI PAGAMENTO</p>







</div>
